import { Box } from '@mui/material'
import { ComparisonTableType } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import { ComparisonTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/Comparison/Comparison.table'

type ComparisonViewProps = {
  data: ComparisonTableType[]
  isLoading: boolean
  width: number
  height: number
}

export const ComparisonView = ({
  data,
  isLoading,
  width,
  height,
}: ComparisonViewProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        overflow: 'auto',
        paddingTop: 3,
      }}
      width={width}
      maxHeight={height - 100}
    >
      <ComparisonTable data={data} isLoading={isLoading} />
    </Box>
  )
}
